import { FormControl, FormLabel, Input, Flex, Select, Button, Box, Checkbox } from '@chakra-ui/react'

export const FiltroPedidos = ({
  isAcompanhaCompras = false,
  isRecebimentoMateriais = false,
  isProduction = false,
  isDevTrocaCompra = false,
  register,
  handleSubmit,
  submitForm,
  errors,
  isSubmitting,
  fornecedores,
  handleFornecedoresSelected,
}) => {
  return (
    <FormControl py=".5rem" as="form" onSubmit={handleSubmit(submitForm)}>
      <Flex flexDir="column" align="center" w="full" px="6rem" justifyContent="space-between" flexWrap="wrap">
        <Flex align="start" justify="space-between" gap="1rem" w="full">
          <Flex gap="4rem">
            {!!isAcompanhaCompras && (
              <Flex alignItems="start" flexDir="column">
                <Input
                  autoFocus
                  maxW="200px"
                  placeholder="Fornecedor"
                  {...register('fornecedor')}
                  borderColor={errors.fornecedor ? 'red.500' : '#378BBF'}
                  variant="flushed"
                  size="sm"
                />
                {!!errors.numero_pedido && <span style={{ color: 'red', fontSize: '.9rem' }}>{errors.numero_pedido.message}</span>}
              </Flex>
            )}
            <Flex alignItems="start" flexDir="column">
              <Input
                autoFocus
                maxW="200px"
                placeholder="Número do pedido"
                {...register('numero_pedido')}
                borderColor={errors.numero_pedido ? 'red.500' : '#378BBF'}
                variant="flushed"
                size="sm"
              />
              {!!errors.numero_pedido && <span style={{ color: 'red', fontSize: '.9rem' }}>{errors.numero_pedido.message}</span>}
            </Flex>
            {!!isRecebimentoMateriais && (
              <Flex alignItems="start" flexDir="column">
                <Input
                  autoFocus
                  maxW="200px"
                  placeholder="Número do pedido de compra"
                  {...register('pedido_compra')}
                  borderColor={errors.pedido_compra ? 'red.500' : '#378BBF'}
                  variant="flushed"
                  size="sm"
                />
                {!!errors.pedido_compra && <span style={{ color: 'red', fontSize: '.9rem' }}>{errors.pedido_compra.message}</span>}
              </Flex>
            )}
          </Flex>
          <Box display="flex" flex={1} minW="400px" gap="1rem" alignItems="start" justifyContent="center">
            <Flex alignItems="start" flexDir="column">
              <Flex alignItems="center" gap=".3rem">
                <FormLabel htmlFor="data_entrada" m="0">
                  De:{' '}
                </FormLabel>
                <Input
                  size="sm"
                  type="date"
                  maxW="200px"
                  {...register('data_entrada')}
                  borderColor={errors.data_entrada ? 'red.500' : '#378BBF'}
                  variant="flushed"
                />
              </Flex>
              {!!errors.data_entrada && <span style={{ color: 'red', fontSize: '.9rem' }}>{errors.data_entrada.message}</span>}
            </Flex>
            <Flex ml="50px" alignItems="start" flexDir="column">
              <Flex alignItems="center" gap=".3rem">
                <FormLabel htmlFor="data_saida" m="0">
                  Até:{' '}
                </FormLabel>
                <Input
                  type="date"
                  maxW="200px"
                  {...register('data_saida')}
                  borderColor={errors.data_saida ? 'red.500' : '#378BBF'}
                  variant="flushed"
                  size="sm"
                />
              </Flex>

              {!!errors.data_saida && <span style={{ color: 'red', fontSize: '.9rem' }}>{errors.data_saida.message}</span>}
            </Flex>
          </Box>

          <Box display="flex" alignItems="start" h="full" gap="10rem">
            <Flex alignItems="center" gap="1rem">
              <label htmlFor={isProduction ? 'pendente_etiqueta' : 'pendente'}>Status:</label>
              <Flex alignItems="start" flexDir="column">
                <Select
                  placeholder="Selecione"
                  id={isProduction ? 'pendente_etiqueta' : 'pendente'}
                  {...register(isProduction ? 'pendente_etiqueta' : 'pendente')}
                  borderColor={errors.pendente_etiqueta || errors.pendente ? 'red.500' : '#378BBF'}
                  defaultValue={!isAcompanhaCompras ? 'S' : ''}
                  size="sm"
                >
                  <option value="">Todos</option>
                  {/*<option value="T">Solicitados</option>*/}
                  <option value="S">Pendente</option>
                  {!!isAcompanhaCompras && <option value="A">Atrasado</option>}
                  {!!isAcompanhaCompras && <option value="B">Atrasado com OBS</option>}
                  <option value="N">Concluído</option>
                  {!isAcompanhaCompras && !isDevTrocaCompra && <option value="N">Recebido</option>}
                  {/* só aparece na tela RecebimentoMateriais */}

                  {/*{!isProduction && !isAcompanhaCompras && <option value="T">Aguardando</option>}*/}
                </Select>
              </Flex>
            </Flex>
          </Box>
        </Flex>

        {!!isRecebimentoMateriais && (
          <Flex gap={2} justifyContent="center" alignItems="center" mt={2}>
            {fornecedores?.map((fornecedor) => (
              <Flex key={fornecedor.id} gap={2} alignItems="center">
                <Checkbox value={fornecedor} onChange={(e) => handleFornecedoresSelected(fornecedor)} size="md" />
                <label htmlFor={fornecedor}>{fornecedor}</label>
              </Flex>
            ))}
          </Flex>
        )}
        <Button
          colorScheme="blue"
          variant="outline"
          mt="1rem"
          type="submit"
          px="2rem"
          bg="#378BBF"
          color="white"
          _hover={{ bg: '#378BBF' }}
          isLoading={isSubmitting}
          size="sm"
        >
          Filtrar
        </Button>
      </Flex>
    </FormControl>
  )
}
